import { gql } from "apollo-angular";

export const POSTAL_CODE_FIELDS_FRAGMENT = gql`
fragment PostalCode on PostalCode {
    countryIso
    postalCode
    city
    state
    stateCode
}
`;

export const GET_POSTAL_CODES = gql`
query GetPostalCodes($input: SearchInput!) {
    getPostalCodes(input: $input) {
        items {
            ...PostalCode
        }
        totalItems
    }
}
${POSTAL_CODE_FIELDS_FRAGMENT}
`;